<ng-container>

  <label [attr.for]="propertyId(index)" class="ma__label">
    {{ propertyLabel(index) }}
    <svg *ngIf="property.tooltip.length > 0" xmlns="http://www.w3.org/2000/svg" [tooltip]="property.tooltip" width="16" height="16" fill="currentColor" class="bi bi-question-circle-fill custom-question" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" />
    </svg>
  </label>

  <p *ngIf="property.type=='label'" class="details">{{property['text']}}</p>

  <p *ngIf="property.type=='labelWithDate'" class="details">{{property['text'] | date:'MM/dd/yyyy' }}</p>

  <div *ngIf="property.type=='customAULlabel'" [innerHtml]="property['text']"></div>
  <!-- <label *ngIf="property.type=='label'" [id]="propertyId(index)"
          [type]="property ['type']">{{property['text']}}</label>

          <label *ngIf="property.type=='labelWithDate'" [id]="propertyId(index)"
          [type]="property ['type']">{{property['text'] | date:'M/d/y h:mm:ss a'}}</label> -->
  


  <div [ngSwitch]="property.type">
 

    <input *ngSwitchCase="'text'" class="form-control ma__input-group"
           [formControl]="propertyControl(index)"
           [placeholder]="property.placeholder || ''"
           [attr.min]="property ['min']"
           [attr.max]="property ['max']"
           [attr.pattern]="property ['pattern']"
           [id]="propertyId(index)"
           [type]="property ['type']"
           autocomplete="off">

        <div *ngSwitchCase="'dropdownWithValueforRTN'">
                <input  class="form-control ma__input-group"
                [formControl]="propertyControl(index)"
                [placeholder]="property.placeholder || ''"
                [attr.min]="property ['min']"
                [attr.max]="property ['max']"
                [attr.pattern]="property ['pattern']"
                (keyup)="enteredRTN($event)"
                [id]="propertyId(index)"
                [type]="text"
                autocomplete="off">
        
             

        <ul id="chemicallist" name="chemicallist" class="form-popup" *ngIf="islistRTN"  style="list-style-type: none;background-color:white;padding-left: 0;width: 96%;">
                <li style="list-style-position:inside;border: 1px solid black;" *ngFor="let opt of property ['options']" (click)="selectRTNItem(opt)">
                &nbsp;&nbsp;<a href="#"> {{ opt }} </a>
                </li>
        </ul>
        </div>


        <div *ngSwitchCase="'dropdownWithValueforChemical'">
                <input  class="form-control ma__input-group"
                [formControl]="propertyControl(index)"
                [placeholder]="property.placeholder || ''"
                [attr.min]="property ['min']"
                [attr.max]="property ['max']"
                [attr.pattern]="property ['pattern']"
                (keyup)="enteredChemical($event)"
                [id]="propertyId(index)"
                [type]="text"
                autocomplete="off">

                <div *ngIf="chemicalValidationShow" class="errorMessage ng-star-inserted">
                        <div class="errorMessage ng-star-inserted">Please enter at least 3 characters to search </div>
                </div>

        <ul class="form-popup" *ngIf="islistChemical"  style="list-style-type: none;background-color:white;padding-left: 0;width: 96%;">
                <li style="list-style-position:inside;border: 1px solid black;" *ngFor="let opt of property ['options']" (click)="selectChemicalItem(opt)">
                &nbsp;&nbsp;<a href="#"> {{ opt }} </a>
                </li>
        </ul>
        </div>
    
    <input *ngSwitchCase="'phone'" phoneMask [preValue]="form.controls[property.key].value" [phoneControl]="propertyControl(index)" class="form-control ma__input-group"
           [ngClass]="{'form-submitted': formSubmitted}"
           [formControl]="propertyControl(index)"
           [placeholder]="property.placeholder || ''"
           [attr.min]="property ['min']"
           maxLength="14"
           [attr.pattern]="property ['pattern']"
           [id]="propertyId(index)"
           [type]="property ['type']">

    <input *ngSwitchCase="'number'" onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" autocomplete=off class="form-control ma__input-group"
           [ngClass]="{'form-submitted': formSubmitted}"
           (keypress)="checkNumberandLength($event, property.maxLength, property.isNumberOnly)"
           [formControl]="propertyControl(index)"
           [placeholder]="property.placeholder || ''"
           [attr.min]="property ['min']"
           [attr.max]="property ['max']"
           [attr.pattern]="property ['pattern']"
           [id]="propertyId(index)"
           [type]="property ['type']">

    <input *ngSwitchCase="'hidden'"
           [formControl]="propertyControl(index)"
           [id]="propertyId(index)"
           [type]="property ['type']"
           [hidden]="true">

    <input *ngSwitchCase="'email'" class="form-control ma__input-group"
           [formControl]="propertyControl(index)"
           [placeholder]="property.placeholder"
           [attr.min]="property ['min']"
           [attr.pattern]="property ['pattern']"
           [id]="propertyId(index)"
           [type]="property ['type']">

    <!--<div *ngSwitchCase="'file'">
            <div class="dropzone" (fileDropped)="upload($event)">
                    <input [formControl]="propertyControl(index)" (change)="upload($event)"  [type]="property['type']" [id]="propertyId(index)" multiple />
                    <h3>Drag and drop file here</h3><h3>or</h3>
                    <h3><button class="btn btn-default">Browse for file</button></h3>
            </div>
    </div>-->
    <input *ngSwitchCase="'date'" (keydown)="DateFieldKeyDown($event)" class="form-control ma__input-group" autocomplete=off
           [formControl]="propertyControl(index)"
           [attr.disabled]=property.disabled
           bsDatepicker
           [placeholder]="property.placeholder"
           [placement]="property.placement || 'bottom'"
           [bsConfig]="{containerClass:'theme-default', showClearButton: true, clearPosition: 'right', dateInputFormat: 'YYYY-MM-DD'}"
           [id]="propertyId(index)">

    <select [id]="property .key" class="form-control js-dropdown-select"
            *ngSwitchCase="'dropdown'"
            [formControl]="propertyControl(index)">
      <option value=""
              *ngIf="!!property .placeholder"
              selected>
        {{ property .placeholder }}
      </option>
      <option *ngFor="let opt of property ['options']"
              [value]="opt">
        {{ opt }}
      </option>
    </select>

    <select [id]="property .key" class="form-control js-dropdown-select" autocomplete="on"
            *ngSwitchCase="'dropdownWithValue'"
            [formControl]="propertyControl(index)">
      <option value=""
              *ngIf="!!property .placeholder"
              selected>
        {{ property .placeholder }}
      </option>
      <option *ngFor="let opt of property ['options']"
              [value]="opt.id">
        {{ opt.name }}
      </option>
    </select>

    <select [id]="property .key" class="form-control js-dropdown-select"
            *ngSwitchCase="'dropdownWithValueforCity'"
            (change)="cityDropdownChanges(property.key)"
            [formControl]="propertyControl(index)">
      <option value=""
              *ngIf="!!property .placeholder"
              selected>
        {{ property .placeholder }}
      </option>
      <option *ngFor="let opt of property ['options']"
              [value]="opt.id">
        {{ opt.name }}
      </option>
    </select>

    <textarea *ngSwitchCase="'textarea'" class="form-control ma__input-group"
              [formControl]="propertyControl(index)"
              [id]="property.key"
              [cols]="property['cols']"
              [rows]="property['rows']"
              [maxlength]="property['maxlength']"
              [minlength]="property['minlength']"
              [placeholder]="property.placeholder"></textarea>
    <!--<button [class]="property['css']" *ngSwitchCase="'button'"
            [id]="property.key"
            [value]="property.value"
            (click)="buttonClick(property.key)"
            [placeholder]="property.placeholder">{{property.value}}</button>
    -->
    <!-- <div *ngSwitchCase="'autocomplete'" class="ng-autocomplete">
             <ng-autocomplete #ngAutoCompleteStatic [data]="data" [searchKeyword]="propertyId()" [formArrayName]="propertyId()"
             [placeholder]="'please enter name'" [itemTemplate]="itemTemplate"
                 [notFoundTemplate]="notFoundTemplate">
             </ng-autocomplete>

             <ng-template #itemTemplate let-item>
                 <a [innerHTML]="item.state"></a>
             </ng-template>

             <ng-template #notFoundTemplate let-notFound>
                 <div [innerHTML]="notFound"></div>
             </ng-template>
     </div> -->
    <!--<div *ngSwitchCase="'radio'">

            <input  *ngFor="let opt of property['options']"
            [formControl]="propertyControl(index)"
            [name]="property.key"
            [value]="opt.value"
            [id]="property.key"
            [type]="property['type']">
            {{opt.value}}

    </div> -->


  </div>
  <div class="errorMessage" *ngIf="isValid">
    <div class="errorMessage" *ngIf="getErrors?.required">{{ property.label }} is required</div>
    <div class="errorMessage" *ngIf="getErrors?.email">Please enter valid email </div>
    <div class="errorMessage" *ngIf="getErrors?.pattern">{{property.errorMessage}} </div>
    <div class="errorMessage" *ngIf="getErrors?.maxlength">This can be max {{property.maxLength}} numbers long.</div>
    <div class="errorMessage" *ngIf="getErrors?.minlength">This can be max {{property.maxLength}} numbers long.</div>
  </div>

</ng-container>







